import {offsetResponse} from '@/transformers/utils'
import {Matcher} from '@/lib/axiosAddTransforms'

const matchers: Matcher[] = [
  {
    test: /^\/clients\/?/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.params
        payload.url = `/bizs/${bizId}/clients/`
        delete payload.params.bizId
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return data
        }
        return {
          results: data.results.map((client) => clientResponse(client)),
          ...propertyResponse(data),
        }
      },
    },
  },
  {
    test: /^\/clients\/?/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.params
        payload.url = `/bizs/${bizId}/clients/`
        delete payload.params.bizId
        return payload
      },
      response: (data) => {
        const {id} = data
        return {
          id: String(id),
        }
      },
    },
  },
  {
    test: /^\/client\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, clientId} = payload.params
        payload.url = `/bizs/${bizId}/clients/${clientId}`
        delete payload.params.bizId
        delete payload.params.clientId
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return clientResponse(data)
      },
    },
  },
  {
    test: /^\/clients\/\$id\/?$/,
    method: 'patch',
    transform: {
      request: (payload) => {
        const {bizId, clientId} = payload.params
        payload.url = `/bizs/${bizId}/clients/${clientId}`
        delete payload.params.bizId
        delete payload.params.clientId
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return clientResponse(data)
      },
    },
  },
  {
    test: /^\/client\/\$id\/bank-accounts?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, id} = payload.data
        payload.url = `/bizs/${bizId}/clients/${id}/bank-accounts`
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return data
        }
        data.results = data.results.map((data) => clientBankResponse(data))
        return data
      },
    },
  },
  {
    test: /^\/client\/\$id\/bank-accounts?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId, id, bank, owner, number} = payload.data
        payload.data = {
          bankCode: bank,
          ownerName: owner,
          number,
        }
        payload.url = `/bizs/${bizId}/clients/${id}/bank-accounts`
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return data
      },
    },
  },
  {
    test: /^\/client\/\$id\/bank-accounts\/\$id?$/,
    method: 'delete',
    transform: {
      request: (payload) => {
        const {bizId, clientId, bankAccountId} = payload.params
        payload.url = `/bizs/${bizId}/clients/${clientId}/bank-accounts/${bankAccountId}`
        delete payload.params.bizId
        delete payload.params.clientId
        delete payload.params.bankAccountId
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return data
      },
    },
  },
]

export default matchers

const clientResponse = (data) => {
  const {
    id, representative = {}, clientType,
  } = data
  delete data.representative
  return {
    ...data,
    id: String(id),
    ownerName: representative?.name,
    clientType: String(clientType),
  }
}

const propertyResponse = (data) => {
  const {next} = data
  return {
    nextOffset: offsetResponse(next),
  }
}

const clientBankResponse = (data) => {
  const {bankCode, ownerName, number, id} = data
  return {
    id: String(id),
    bank: bankCode,
    number,
    owner: ownerName,
  }
}
